'use client';
import React, { useEffect, useRef, useState } from 'react';
import { SAAS_SIGNUP_URL } from '@/lib/saas';

export default function FinalCTASection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.disconnect(); } },
      { threshold: 0.2 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section className="py-24 px-4 sm:px-6 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/8 via-transparent to-secondary/8" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] blob-primary opacity-20 rounded-full pointer-events-none" />

      <div
        ref={ref}
        className={`max-w-4xl mx-auto text-center relative z-10 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        {/* Spinning badge */}
        <div className="flex justify-center mb-8">
          <div className="relative w-24 h-24 flex items-center justify-center">
            <svg className="animate-spin-slow w-full h-full absolute" viewBox="0 0 100 100">
              <path id="ctaCircle" d="M 50,50 m -37,0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" fill="transparent" />
              <text fontSize="8.5" fontFamily="DM Sans" fontWeight="700" letterSpacing="3" fill="var(--primary)">
                <textPath href="#ctaCircle" startOffset="0%">
                  NEGÓCIO FÁCIL • 14 DIAS GRÁTIS •
                </textPath>
              </text>
            </svg>
            <div className="w-12 h-12 rounded-full bg-primary/20 border border-primary/30 flex items-center justify-center">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary">
                <polygon points="5 3 19 12 5 21 5 3"/>
              </svg>
            </div>
          </div>
        </div>

        <h2 className="text-display font-black text-foreground mb-6">
          Comece hoje mesmo a{' '}
          <span className="gradient-text">transformar</span>{' '}
          sua empresa.
        </h2>
        <p className="text-xl text-muted-foreground leading-relaxed mb-10 max-w-2xl mx-auto">
          30+ funcionalidades, IA integrada, suporte 24h e 14 dias completamente gratis. Sem cartão, sem fidelidade. Sua empresa merece um sistema completo.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={`${SAAS_SIGNUP_URL}?trial=14&utm_source=final-cta`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary px-10 py-5 text-lg inline-flex items-center gap-3"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
            Criar Conta Gratuitamente
          </a>
        </div>

        <p className="text-sm text-muted-foreground mt-6">
          ✓ 14 dias grátis &nbsp;·&nbsp; ✓ Sem cartão de crédito &nbsp;·&nbsp; ✓ Cancele quando quiser &nbsp;·&nbsp; ✓ Suporte especializado
        </p>
      </div>
    </section>
  );
}